module.exports = __webpack_public_path__ + "img/pwd_pb.ad51fe54.jpg";